import React__default from 'react';
import 'react/jsx-runtime';
import Check from '../../../node_modules/@zooplus/icons/dist/es/components/Check.js';
import { P1 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import styles from './Benefits.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const Benefits = (props) => {
    const { site } = useSiteContext();
    const { t } = useTranslation(site.realm);
    return (React__default.createElement("ul", { className: `${styles.benefits} ${props.className}` },
        React__default.createElement("li", null,
            React__default.createElement(Check, null),
            React__default.createElement(P1, { className: styles.benefitText }, t('checkout.benefits.first'))),
        React__default.createElement("li", null,
            React__default.createElement(Check, { className: styles.icon }),
            React__default.createElement(P1, { className: styles.benefitText }, t('checkout.benefits.second'))),
        React__default.createElement("li", null,
            React__default.createElement(Check, { className: styles.icon }),
            React__default.createElement(P1, { className: styles.benefitText }, t('checkout.benefits.third')))));
};

export { Benefits };
//# sourceMappingURL=Benefits.js.map
